module.exports = __webpack_public_path__ + "fb214ad86e93d07acc2f2b5c9df115dc.pdf";